// Traduções dos enums do domínio usados no app do viajante (referência por código).

export const pt = {
  tripStatus: {
    rascunho: 'Rascunho',
    aguardando_aprovacao: 'Aguardando aprovação',
    aprovada: 'Aprovada',
    em_andamento: 'Em andamento',
    finalizada: 'Finalizada',
    em_prestacao: 'Em prestação',
    encerrada: 'Encerrada',
    rejeitada: 'Rejeitada',
  },
  formaCusteio: {
    adiantamento: 'Adiantamento',
    cartao_empresa: 'Cartão empresa',
    reembolso: 'Reembolso',
  },
  tipoLocomocao: {
    carro: 'Carro',
    aviao: 'Avião',
    onibus: 'Ônibus',
    outro: 'Outro',
  },
};

export const es: typeof pt = {
  tripStatus: {
    rascunho: 'Borrador',
    aguardando_aprovacao: 'Esperando aprobación',
    aprovada: 'Aprobada',
    em_andamento: 'En curso',
    finalizada: 'Finalizada',
    em_prestacao: 'En rendición',
    encerrada: 'Cerrada',
    rejeitada: 'Rechazada',
  },
  formaCusteio: {
    adiantamento: 'Adelanto',
    cartao_empresa: 'Tarjeta empresa',
    reembolso: 'Reembolso',
  },
  tipoLocomocao: {
    carro: 'Auto',
    aviao: 'Avión',
    onibus: 'Autobús',
    outro: 'Otro',
  },
};
